import { ArrowRight } from "lucide-react";
import { Reveal, Stagger, StaggerItem } from "../Reveal";

export default function ProfileApproach({ steps }) {
  if (!steps?.length) return null;
  return (
    <section id="approche" className="bg-paper py-24 md:py-32" data-testid="profile-approach">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <Reveal>
          <span className="label-mono text-gold">03 — Mon approche</span>
          <h2 className="font-display text-4xl md:text-6xl font-semibold mt-4 tracking-tight max-w-4xl">Une philosophie d'amélioration industrielle.</h2>
          <p className="text-ink/60 text-lg mt-5 max-w-2xl">Un cycle éprouvé sur le terrain — de l'observation du Gemba jusqu'à l'ancrage durable des progrès.</p>
        </Reveal>
        <Stagger className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-ink/10 border hairline rounded-sm overflow-hidden mt-14">
          {steps.map((s, i) => (
            <StaggerItem key={s.step || i} className="bg-paper p-8 min-h-[210px] flex flex-col hover:bg-white transition-colors duration-500" data-testid={`approach-step-${i}`}>
              <div className="flex items-center justify-between">
                <span className="font-display text-4xl font-semibold text-gold/80">{s.step}</span>
                {i < steps.length - 1 && <ArrowRight size={17} className="text-ink/25" />}
              </div>
              <h3 className="font-display text-xl font-semibold mt-5">{s.title}</h3>
              <p className="text-ink/55 text-sm mt-3 leading-relaxed">{s.description}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
}
